// Keep in sync with the `landscape-or-desktop` mixin in src/styles/mixins.scss.
export const LANDSCAPE_OR_DESKTOP_QUERY = '(orientation: landscape), (min-width: 769px)';

export const TILE_GEOMETRY = {
  mobile: { tileWidth: 120, tileGap: 8, amountMaxFont: 13 },
  desktop: { tileWidth: 160, tileGap: 8, amountMaxFont: 17 },
} as const;

export const TILE_STRIDE = TILE_GEOMETRY.desktop.tileWidth + TILE_GEOMETRY.desktop.tileGap;

// Continuous scroll speed of the conveyor.
export const SCROLL_SPEED_PX_PER_SEC = 40;

// A random subset of tiles "snap" in: once such a tile is halfway into view it
// bursts forward at SCROLL_SPEED_PX_PER_SEC * SNAP_SPEED_MULTIPLIER for the rest
// of its own width, then settles back to the normal speed.
export const SNAP_PROBABILITY = 0.35;
export const SNAP_SPEED_MULTIPLIER = 10;

// Clamp the per-frame delta so a tab-switch, breakpoint, or GC pause can't
// lurch the belt forward by a huge jump on the first frame back.
export const MAX_FRAME_SECONDS = 0.05;

// Extra off-screen tiles kept on either side so recycling at the edges is seamless.
export const VIEWPORT_BUFFER_TILES = 2;
export const WINNERS_ENDPOINT = 'user/winners';
